import * as React from 'react';
import clsx from 'clsx';
import { Typography } from '../typography';
import styles from './styles.module.css';
import { useStyleProps, colorToken } from '../utils';
/**
 * `<Label />` - Компонент, для отображения текстового статуса элемента.
 *
 * @example ``` tsx
 <Label>Best buy</Label>
 * ```
 */
export const Label = /*#__PURE__*/React.forwardRef(function Label({
  className = '',
  color = 'text-primary',
  background = 'control-minor',
  variant = '',
  children,
  ...props
}, ref) {
  const styleProps = useStyleProps({
    color,
    background
  }, labelStyleProps);
  const classNames = React.useMemo(() => clsx(styles.label, styles[variant], className), [className, variant]);
  const title = typeof children === 'string' ? children : '';
  const labelProps = {
    ...styleProps,
    title,
    className: classNames,
    ref
  };
  return /*#__PURE__*/React.createElement("span", {
    ...labelProps,
    ...props
  }, /*#__PURE__*/React.createElement(Typography, {
    className: styles.textStyle,
    variant: "caption"
  }, children));
});
const labelStyleProps = {
  background: ['backgroundColor', colorValue],
  color: ['color', colorValue]
};
function colorValue(value) {
  return colorToken(value);
}